{
  "RESET_PASSWORD": {
    "TITLE": "Restablecer contraseña",
    "DESCRIPTION": "Introduzca la dirección de correo electrónico que utiliza para iniciar sesión en Chatwoot para obtener las instrucciones de restablecimiento de contraseña.",
    "GO_BACK_TO_LOGIN": "Si desea volver a la página de inicio de sesión,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Por favor ingrese su email.",
      "ERROR": "Por favor ingrese un email válido."
    },
    "API": {
      "SUCCESS_MESSAGE": "El enlace para restablecer la contraseña ha sido enviado a tu correo electrónico.",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
    },
    "SUBMIT": "Enviar"
  }
}
